import { render, staticRenderFns } from "./summary.vue?vue&type=template&id=e88804b2&scoped=true"
import script from "./summary.vue?vue&type=script&lang=ts"
export * from "./summary.vue?vue&type=script&lang=ts"
import style0 from "./summary.vue?vue&type=style&index=0&id=e88804b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88804b2",
  null
  
)

export default component.exports